import { Typography, DialogContent } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'
// import { useTranslation } from 'react-i18next'
// import { parseISO } from 'date-fns'

// import { defaultTimeZoneFormat } from '@hapana/shared/utils/date.util'
// import penIcon from '@hapana/shared/web/styles/assets/svgs/pen-small.svg'
import {
  SIZES,
  CLOSE_TYPES,
} from '@hapana/shared/web/components/shared/dialog/dialog-layout/dialog-layout.constants'
import DialogLayout from '@hapana/shared/web/components/shared/dialog/dialog-layout/dialog-layout.component'
import { useDialog } from '@hapana/shared/web/components/shared/dialog/dialog.hooks'
// import AddEditNote from '@components/check-in-widget/modal-add-edit-note/modal-add-edit-note.component'
// import { useSiteConfiguration } from '@hapana/shared/web/hooks/siteConfiguration.hooks'

import { styles } from '../notes-properties.styles'

const ModalOpenNote = ({ date, description, title, name }) => {
  // const { t } = useTranslation(['checkIn'])
  // const { data } = useSiteConfiguration()

  const { popDialog } = useDialog()
  // const openEditModal = () =>
  //   pushDialog(AddEditNote, {
  //     showEditTitle: true,
  //     description,
  //     name,
  //   })

  return (
    <DialogLayout
      closeType={CLOSE_TYPES.ICON}
      closeAction={() => popDialog()}
      size={SIZES.XS}
      title={title}
      // primaryAction={{
      //   label: t('checkIn:alerts.notesAndPropertiesAlerts.actionToNote.editNote'),
      //   action: openEditModal,
      //   props: {
      //     startIcon: penIcon,
      //   },
      // }}
      customFooterContent={date}
    >
      <DialogContent>
        <Typography typography="medium" color="gray.80" sx={styles.openNoteDescription}>
          {description}
        </Typography>
      </DialogContent>
    </DialogLayout>
  )
}

ModalOpenNote.propTypes = {
  date: PropTypes.string,
  description: PropTypes.string,
  title: PropTypes.string,
  name: PropTypes.string,
}

ModalOpenNote.defaultProps = {
  date: '',
  description: '',
  title: '',
}

export default ModalOpenNote
